import { getSmoothStepPath } from "@xyflow/react";

// How far a parallel edge's horizontal run is moved up or down so neighbouring edges and their
// labels don't share a line. 0.35 keeps two labels (about 22px tall) from touching at 80px spacing.
const STAGGER_RATIO = 0.35;
// Where a loop-back edge's label sits along its vertical run, measured from its source
const BACK_EDGE_LABEL_POSITION = 0.25;
// Forward edges put their label this far along from the source (0 = at the source, 1 = at the
// target) instead of at the middle, so it stays off the vertical run of a loop-back edge.
const FORWARD_LABEL_POSITION = 0.4;
// Where a loop-back edge's vertical run sits between its source and target, measured from the
// source. Close enough to the source that it doesn't run through the nodes' cards.
const BACK_EDGE_BEND_POSITION = 0.4;
const DEFAULT_GAP = 20;
const BACK_EDGE_GAP_STEP = 16;

// Smoothstep path for an edge shifted `offsetX` sideways (see OffsetLabelEdge). Returns
// [path, labelX, labelY]. With no offset it is the stock smoothstep path.
export const getOffsetEdgePath = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  offsetX = 0,
}) => {
  const shifted = {
    sourceX: sourceX + offsetX,
    sourceY,
    targetX: targetX + offsetX,
    targetY,
    sourcePosition,
    targetPosition,
  };
  if (!offsetX) return getSmoothStepPath(shifted);

  const dx = shifted.targetX - shifted.sourceX;
  // The edge on the inside of a bend goes on the inside, so the pair nests instead of crossing
  const stagger = offsetX * STAGGER_RATIO * (dx === 0 ? 1 : -Math.sign(dx));
  const isBackEdge = targetY < sourceY;

  if (isBackEdge) {
    return getSmoothStepPath({
      ...shifted,
      centerX:
        shifted.sourceX + dx * BACK_EDGE_BEND_POSITION + offsetX / 2,
      centerY: sourceY + (targetY - sourceY) * BACK_EDGE_LABEL_POSITION + stagger,
      offset: DEFAULT_GAP + (offsetX > 0 ? BACK_EDGE_GAP_STEP : 0),
    });
  }
  const [path, , labelY] = getSmoothStepPath({
    ...shifted,
    centerY: (sourceY + targetY) / 2 + stagger,
  });
  return [path, shifted.sourceX + dx * FORWARD_LABEL_POSITION, labelY];
};
